import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6

import LoginFormulari from './loginFormulari';
import LoginImatges from './loginImatges';
import Peu from '../peu/peu';
import logoSMC from '../../images/logos/logo_smc.png';
import logoXOM from '../../images/logos/logo_XOM.png';

class Login extends Component {

    render() {
        return (
            <div className='login-grid'>
                <div className='login'>
                    <div className='login-zona-formulari'>
                        <div className='login-title-logos'>
                            <div className='login-logos'>
                                <img src={logoSMC} alt='logoSMC' />
                                <img src={logoXOM} alt='logoXOM' />
                            </div>
                            <h1>Xarxa d'Observadors Meteorològics</h1>
                        </div>
                        <div className='login-formulari-contenidor' >
                            <LoginFormulari router={this.props.router} />
                        </div>
                        <div className='login-participacio'>
                            Per accedir en aquest portal has de ser membre de la <a href="http://www.meteo.cat/wpweb/divulgacio/equipaments-meteorologics/observadors-meteorologics/">XOM</a>.
                        </div>
                    </div>
                    <div className='login-zona-imatges'>
                        <LoginImatges />
                    </div>
                </div>
                <Peu />
            </div>
        );
    }
}

Login.propTypes = {
    children: PropTypes.element,
    location: PropTypes.object,
    router: PropTypes.object
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login.js